import React from 'react';
import type { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import styled from 'types/theme.types';
import ControlledRadioButtons from 'components/common/form-controlled/controlled-radio-buttons';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import type { VcsModalFormValues } from './access-card/use-connection-modal-access-card-form.hook';

export type BlockRadioButtonProps = {
  options: Array<CheckboxOptionType | string | number>;
  form: UseFormReturnType<VcsModalFormValues>;
};

export const VcsConnectionModalFormAuthenticationTypeButton = ({ options, form }: BlockRadioButtonProps) => (
  <Container>
    <ControlledRadioButtons
      label={{ id: 'templates.add.new.field.authorize.type' }}
      name={'authenticationType'}
      form={form}
      block
      options={options}
      optionType={'button'}
      buttonStyle={'solid'}
    />
  </Container>
);

// No checked override here: the segmented styling (lime fill on the selected segment, dark text, lime
// frame and dividers) lives in the RadioButtons wrapper itself, matching Figma node 2092:11719.
const Container = styled.div``;
